<template>
  <div :class="clContainer()">
    <div v-if="message.data.pictures" :class="clSub('pictures')">
      <ul class="list-reset list-h">
        <li v-for="(picture, index) in message.data.pictures" :key="index">
          <button
            v-if="picture.src"
            class="btn-plain"
            @click="showFile(index, $event)"
          >
            <img :src="picture.src" />
          </button>

          <spinner v-else size="sm" class="align-self-center"></spinner>
        </li>
      </ul>
    </div>

    <div :class="clSub('data')">
      <div :class="clSub('title')">
        <h2>
          {{ __(`messages.jobs.common.${message.sourceTypeName}.title`) }}
        </h2>

        <small :class="clSub('date')"
          >{{ message.trigger_user.name }},
          {{ dateOutput(message.created_at) }}</small
        >
      </div>

      <div v-if="message.context_info.fitting" class="mt-xs mb-xs">
        <job-fitting :fitting="message.context_info.fitting"></job-fitting>
      </div>
      <div v-else-if="message.data.rating">
        <job-rating-display
          :rating="message.data.rating"
          :icon-src="icon"
        ></job-rating-display>
      </div>
      <span v-else-if="message.context_info.part">
        {{ message.context_info.part.name }}
        <div v-if="message.data.check_title">
          {{ message.data.check_title }}
        </div>
      </span>
      <p v-else-if="message.data.reason">
        <span>{{ __("jobs.components.messages.common.labels.reason") }}</span>
        {{ message.data.reason.reason }}
      </p>
      <div v-else-if="message.context_info.requests">
        {{
          __("jobs.components.messages.common.labels.requests", {
            name: message.trigger_user.name,
          })
        }}
        <div class="mt-xxs">
          <job-list-date-item
            v-for="request in message.context_info.requests"
            :date="request.date"
            :key="request.date.id"
            class="d-inline-block mr-xs"
          >
          </job-list-date-item>
        </div>
      </div>

      <template v-if="message.data.text">
        <div
          v-tif="`messages.jobs.common.${message.sourceTypeName}.text_label`"
        ></div>
        <div :class="clSub('text')" v-html="message.data.text"></div>
      </template>
    </div>
  </div>
</template>

<script>
import Message from "smartdoors-shared/js/components/Messages/Message";
import JobFitting from "smartdoors-shared/js/components/Jobs/JobFitting";
import ShowsJobDateItems from "../../mixins/ShowsJobDateItems";
import { toDate } from "smartdoors-shared/js/helpers/common";
import api from "../../helper/api";

export default {
  extends: Message,
  mixins: [ShowsJobDateItems],
  components: {
    "job-fitting": JobFitting,
  },
  watch: {
    message: {
      immediate: true,
      handler: function (message) {
        this.message = message;

        if (message.data && "pictures" in message.data) {
          for (const picture of message.data.pictures) {
            if (!("src" in picture) || !picture.src) {
              const pictureDownloadApiPath =
                this.config.api.urls.files.download + "/" + picture.route;
              Vue.set(picture, "src", null);

              ((pic) => {
                api.download(pictureDownloadApiPath).then((url) => {
                  Vue.set(pic, "src", url);
                });
              })(picture);
            }
          }
        }
      },
    },
  },
  methods: {
    dateOutput(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = toDate(dateString);

      return (
        date.toLocaleDateString(undefined, options) +
        " (" +
        date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        }) +
        ")"
      );
    },
  },
};
</script>